export default {
  install(Vue) {
    Vue.prototype.$ApiUrl = process.env.VUE_APP_API_URL;
    let apiUrl = process.env.VUE_APP_API_URL;

    Vue.prototype.$apiImagesUrl = `${apiUrl}images`,
    Vue.prototype.$apiVideosUrl = `${apiUrl}videos`,
    Vue.prototype.$apiAudiosUrl = `${apiUrl}audios`,
    Vue.prototype.$apiFilesUrl = `${apiUrl}files`;
    
    Vue.prototype.$urunResimUrl = {
      origin: `${apiUrl}images/urunler/origin/`,
      default: `${apiUrl}images/urunler/origin/shoe.png`,
      sm: `${apiUrl}images/urunler/resized/460/318/`,
      md: `${apiUrl}images/urunler/resized/241/185/`,
      lg: `${apiUrl}images/urunler/resized/150/75/`,
    };

    Vue.prototype.$moduleTypes = {
      apiType: "Api",
      modulesType: "Modules",
      pluginsType: "Plugins",
    };

  },
};
